import React from 'react'
import styled from 'styled-components'
import FooterLinks from './components/FooterLinks'
import DesktopLogos from './components/DesktopLogos'

const Wrapper = styled.div`
  background-color: rgba(240, 240, 240, 1);
`

function DesktopFooter (props) {
  return (
    <Wrapper>
      <FooterLinks/>
      <DesktopLogos/>
    </Wrapper>
  )
}

export default DesktopFooter



// WEBPACK FOOTER //
// ./src/organisms/Footer/DesktopFooter.js